import styled from "styled-components";
import { colors } from "../../utils";
import Accordion from "@mui/material/Accordion";

export const SideBarOpened = styled.div`
  width: 20vw;
  height: 100%;
  border-right: 1px solid #E1E1E1;
`;

export const SideBarHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 8vh;
  padding-left: 14px;
  border-bottom: 1px solid rgb(225, 225, 225);
`;

export const Row = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const SideBarContent = styled.div`
  overflow-y: scroll;
  overflow-x: hidden;
  height: 90vh;
  padding-left: 15px;
  padding-top: 15px;
`;

export const MenuItem = styled(Accordion)`
  margin-top: 0px;
  box-shadow: none;
  border: none;
  outline: none;
`;

export const MenuItemHeader = styled.h3`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  height: 48px;
  background-color: #F6F7F9;
  color: red;
  ${({ isSelected }) =>
    isSelected &&
    `
    background-color: ${colors.PrimaryPurple100};
    box-shadow: -3px 0px 0px 0px #8126DB inset;
    `
  }
  p {
   color: ${({ isSelected }) => (isSelected ? colors.PrimaryPurple800 : colors.textSecondary)}; 
  }
`;